export interface PaginatedResponse<T> {
  items: T[];
  totalItems: number;
  size: number;
  page: number;
  totalPages: number;
  last: boolean;
}

export const emptyPaginatedResponse: PaginatedResponse<any> = {
  items: [],
  totalItems: 0,
  size: 0,
  page: 0,
  totalPages: 0,
  last: true,
};

export interface PaginatedRequestOptions {
  page?: number;
  size?: number;
  sort?: string;
  field?: string;
  fieldId?: string;
  filter?: string;
  search?: string;
  unpaged?: boolean;
}

export const DEFAULT_PAGINATED_REQUEST_OPTIONS = {
  page: 0,
  size: 25,
};
